<template>
  <div>
    <a-space size="middle" class="search_space">
      <a-range-picker v-model:value="inputs.dateRange" :placeholder="['开始时间', '结束时间']" @change="handleChangeDate" :ranges="{
          '今天': [moment(), moment()],
          '最近7天': [moment().subtract(6, 'days'), moment()],
          '本周': [  moment().startOf('week'), moment().endOf('week')],
          '本月': [  moment().startOf('month'), moment().endOf('month')],
          '近一年': [moment().subtract(1, 'year'), moment()], 
        }" style="width: 360px" />
      <a-button type="primary" shape="circle" @click="search">
        <template #icon>
          <SearchOutlined />
        </template>
      </a-button>
      <a-button @click="resetForm">重置</a-button>
    </a-space>

    <a-table class="ant-table-striped" :columns="columns" :data-source="data" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id" :pagination="{ pageSize: 12 }">
      <template #name="{ record }">
        {{ record.customer?.name || '' }}
      </template>
      <template #mobile="{ record }">
        {{ record.customer?.mobile || '' }}
      </template>
      <template #source="{ record }">
        {{ record.customer?.sdmSource?.clubName || '' }}
      </template>
      <template #isNewCustomer="{ record }">
        <span v-if="record.customer?.sdmSource" style="color: #52c41a;">
          <CheckCircleOutlined /> 新客
        </span>
        <!-- <span v-else style="color: #bfbfbf;">
          <CloseCircleOutlined /> 老客
        </span> -->
      </template>
      <template #doctorName="{ record, text }">
        <a v-if="record.medicalRecordUuid" :href="'https://shidaojiankang.com/customer/medicalRecord/detail/' + record.medicalRecordUuid" target="_blank">
          {{ text }}
        </a>
        <span v-else>—</span>
      </template>
      <template #tcmResult="{ record, text }">
        <a href="javascript:;" @click="goMicroTest(record)">{{ text }}</a>
      </template>
    </a-table>
  </div>

  <microDetail v-model:visible="visible" :record="selectedRow" />
</template>

<script>
import { SearchOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons-vue';
import moment from 'moment';
import { Search } from '/src/api/microTest';
import microDetail from '@/components/microTest/detail.vue';

export default {
  components: {
    SearchOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    microDetail,
  },
  name: '小医微测管理',
  data() {
    return {
      inputs: {
        dateRange: [], // [moment, moment]
      },
      visible: false,
      selectedRow: null,
      data: [],
      columns: [
        { title: '日期', dataIndex: 'date', key: 'date', width: '10%' },
        { title: '客户', dataIndex: 'name', key: 'name', width: '10%', slots: { customRender: 'name' } },
        { title: '电话', dataIndex: 'mobile', key: 'mobile', width: '10%', slots: { customRender: 'mobile' } },
        { title: '是否新客', dataIndex: 'isNewCustomer', key: 'isNewCustomer', width: '10%', slots: { customRender: 'isNewCustomer' } },
        { title: '来源', dataIndex: 'source', key: 'source', width: '10%', slots: { customRender: 'source' } },
        { title: '当日看诊信息', dataIndex: 'doctorName', key: 'doctorName', width: '15%', slots: { customRender: 'doctorName' }, },
        { title: '小医微测', dataIndex: 'tcmResult', key: 'tcmResult', width: '15%', slots: { customRender: 'tcmResult' }, },
      ],
    };
  },
  mounted() {
    this.setDefaultDate();
    this.search();
  },
  methods: {
    moment,
    setDefaultDate() {
      const start = moment().subtract(6, 'days');
      const end = moment();
      this.inputs.dateRange = [start, end];
    },
    handleChangeDate(dates, dateStrings) {
      console.log('Date range changed:', dateStrings);
    },
    resetForm() {
      this.setDefaultDate();
      this.search();
    },
    goMicroTest(record) {
      this.selectedRow = record;
      this.visible = true;
    },
    async search() {
      const range = this.inputs.dateRange;
      if (!range || range.length !== 2) {
        this.setDefaultDate();
      }

      const [start, end] = this.inputs.dateRange;
      const params = {
        includeMr: true,
        dateFrom: start.format('YYYY-MM-DD'),
        dateTo: end.format('YYYY-MM-DD'),
      };

      try {
        const res = await Search(params);
        if (res.errCode === 0) {
          this.data = res.data;
        } else {
          this.$message.error(res.message || '查询失败');
        }
      } catch (error) {
        console.error('Search error:', error);
        this.$message.error('请求异常，请稍后重试');
      }
    },
  },
};
</script>

<style scoped>
</style>